import { useLayoutEffect } from "react";
import { motion } from "framer-motion";
import "../../scss/global.scss";
import "./home.scss";
import Banner from "../../animations/banner";

const Home: React.FC = () => {
    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    });

    const variants = {
        hidden: { opacity: 0, y: 10 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.25 },
        },
    };

    return (
        <>
            <div className="home-one">
                <Banner />
            </div>
            <div className="contain-wrapper holding-content">
                
                <div className="copy-wrapper">
                    <motion.h1
                        initial="hidden"
                        whileInView="visible"
                        variants={variants}
                        viewport={{ once: true }}
                    >
                        11,315 sq ft of elegant,&nbsp;understated <br />workspace in the heart of&nbsp;Mayfair
                    </motion.h1>
                    
                    <motion.h2
                        initial="hidden"
                        whileInView="visible"
                        variants={variants}
                        viewport={{ once: true }}
                    >
                        3,500 - 4,000 SQ FT FLOOR&nbsp;PLATES<br />COMPLETING Q1 2026
                    </motion.h2>
                    
                    <motion.p
                        initial="hidden"
                        whileInView="visible"
                        variants={variants}
                        viewport={{ once: true }}
                    >
                        FULL WEBSITE COMING SOON
                    </motion.p>
                        
                        
                    
                </div>
                
            </div>
        </>
    );
};

export default Home;
